import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d3659eb4-0ea3-426f-b27c-7df2a5593b81", content: "T = 0.76 N<br>v = 2 632 m/s", options: {} },
  { id: "4f2727c5-9424-40d6-8993-be5c57c5f14b", content: "T = 65 N<br>v = 1 622 m/s", options: {} },
  { id: "413937f0-b3cb-4c06-acec-45492a9ca76c", content: "T = 262 N<br>v = 52 m/s", options: {} },
  { id: "b2b68208-7bd8-4af7-b5f0-46f56053ab07", content: "T = 262 N<br>v = 1 622 m/s", options: {} },
  { id: "f1f8acb7-25d2-4b45-8a2c-bfa393b0e0d0", content: "T = 65 N<br>v = 2632 m/s", options: {} },
  { id: "b32036c3-7782-4b75-9592-2b2a95acbdee", content: "T = 1465 N<br>v = 563 m/s", options: {} },
];

export const task: Task = {
  id: "6592ed9e-dd99-46ab-9627-615997ea6502",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4f2727c5-9424-40d6-8993-be5c57c5f14b"],
};
